import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { signupFields } from "../../constants/formFields"
import FormAction from "./FormAction";
import Input from "./Input";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";

const fields=signupFields;
let fieldsState={};

fields.forEach(field => fieldsState[field.id]='');

export default function Signup(){
  const navigate = useNavigate();
  
  const [signupState,setSignupState]=useState(fieldsState);
  const [signupSuccess, setSignupSuccess] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const handleChange=(e)=>setSignupState({...signupState,[e.target.id]:e.target.value});

  const handleSubmit=(e)=>{
    e.preventDefault();
    console.log(signupState)
    createAccount()
  }


  const createAccount = () => {
    const { firstName, lastName, email, mobile, password, role } = signupState;
  
    
 
    const user = {
      firstName,
      lastName,
      email,
      mobile,
      password,
      role:"user",
     
    };
  
    axios.post('https://backend.grahaksathi.in/api/user/signup', user)
      .then(response => {
        console.log(response.data);
        toast.success("User Created Successfully! Login with your credentials.")
        setSignupSuccess(true);
        
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 409) {
          
          setEmailError(true);
          toast.error("This email is already registered");
        }
      });
    
      
    };
    // if (signupSuccess) {
    //   // Redirect to the login page after successful signup
     
    //   return <Navigate to="/login" state={{ successMessage: `Successfully registered .` }} />;
    // }
    if (signupSuccess) {
      // Success case
      // console.log("API Response:", data);
      Swal.fire({
        icon: "success",
        title: "SignUp Successful!",
        text: "Login To Continue",
      }).then((result) => {
        if (result.isConfirmed) {
         navigate('/login')
        }
      });
    } 
    return(
      <>
      <ToastContainer/>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <div className="">
        {
                fields.map(field=>
                        <Input
                            key={field.id}
                            handleChange={handleChange}
                            value={signupState[field.id]}
                            role={signupState[field.role]}
                            labelText={field.labelText}
                            labelFor={field.labelFor}
                            id={field.id}
                            name={field.name}
                            type={field.type}
                            isRequired={field.isRequired}
                            placeholder={field.placeholder}
                       
                    />
                
                )
            }
          <FormAction handleSubmit={handleSubmit} text="Signup" />
        </div>

         

      </form>
      </>
    )
}